import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorCodes,
  ColorSvg,
  ContainedButton,
  HContainer,
  Spinner,
  Text,
  VContainer,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  InputOtpBox,
  PopUpBanner
} from 'components';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const OtpCard = props => {

  const [
    state,
    setState
  ] = React.useState({
    error: null,
    inputFocusIndex: 0,
    otpInput: [],
    otp: null
  });

  const handleKeyDown = (event) => {

    if (!event) {

      return;
    }

    if (event.key === 'Backspace') {

      setState(prevState => ({
        ...prevState,
        inputFocusIndex: prevState.inputFocusIndex - 1 < 0 ? 0 : prevState.inputFocusIndex - 1
      }));
    }

    if (event.key === 'Enter' && state.otp?.length === props.otpLength) {

      submitOtp();
    }
  };

  const onOtpChange = (value, index) => {

    if (value?.length > 1) {

      return;
    }

    const trimmedValue = value.trim();

    if (trimmedValue.length === 1) {

      setState(prevState => ({
        ...prevState,
        inputFocusIndex: prevState.inputFocusIndex + 1
      }));
    }

    let newOtpInput = state.otpInput;
    newOtpInput[index] = trimmedValue;

    setState(prevState => ({
      ...prevState,
      otpInput: newOtpInput,
      otp: newOtpInput.join('')
    }));
  };

  const createInputList = () => {

    let inputList = [];

    for (let i = 0; i < props.otpLength; i ++) {

      inputList.push(

        <VContainerVH
          key={`otp-input-${i}`}
          width={'50px'}
          height={'50px'}
          border={`solid 1px ${CustomColors.Grey6}`}
          borderRadius={'4px'}
          margin={'0 16px 0 0'}>

        <InputOtpBox
          onFocus={() => {

            setState(prevState => ({
              ...prevState,
              inputFocusIndex: i
            }));
          }}
          onChange={(value) => onOtpChange(value, i)}
          focus={state.inputFocusIndex === i}
          value={state.otpInput[i] || ''}
          onKeyDown={handleKeyDown}/>

        </VContainerVH>
      );
    }

    return inputList;
  };

  const submitOtp = async () => {

    props?.onSubmitOtp?.(state.otp);
  };

  const renderOtpCard = () => {

    return (

      <VContainerVH>

        <ColorSvg
          src={props.closeIcon}
          color={props.closeIconColor}
          width={props.closeIconWidth}
          height={props.closeIconHeight}
          padding={props.closeIconPadding}
          margin={props.closeIconMargin}
          onClick={props.onClose}/>

          <Text
            fontSize={props.titleSize}
            color={props.titleColor}
            fontWeight={props.titleWeight}
            textAlign={props.titleAlign}
            lineHeight={props.titleLineHeight}>

              {props.title}
          </Text>

          <Text
            fontSize={props.subtitleSize}
            color={props.subtitleColor}
            textAlign={props.subtitleAlign}
            padding={props.subtitlePadding}
            lineHeight={props.subtitleLineHeight}>

              {props.subtitle}

          </Text>

          <VContainer
            margin={'0 0 32px'}>

            <HContainer
              margin={'0 0 16px'}>

                { createInputList() }

            </HContainer>

            <Text
              color={props.resendOtpColor}
              fontSize={props.resendOtpSize}
              lineHeight={props.resendOtpLineHeight}
              fontFamily={props.resendOtpFontFamily}
              onClick={() => {

                props.onResendOtp?.();

                setState(prevState => ({
                  ...prevState,
                  otpInput: [],
                  otp: null,
                  inputFocusIndex: 0
                }));
              }}>

                {props.resendOtpText}
            </Text>

          </VContainer>

          <ContainedButton
            borderRadius={props.buttonBorderRadius}
            activeBackgroundColor={props.buttonActiveBackgroundColor}
            width={props.buttonWidth}
            maxWidth={props.buttonMaxWidth}
            height={props.buttonHeight}
            minHeight={props.buttonMinHeight}
            onClick={submitOtp}
            isEnabled={state.otp?.length === props.otpLength}
            disabledBackgroundColor={props.buttonDisabledBackgroundColor}
            disabledBorderColor={props.buttonDisabledBorderColor}
            showSpinner={props.isVerifyLoading}>

              <Text
                color={state.otp?.length === props.otpLength ? props.buttonActiveColor : props.buttonDisabledColor}
                fontSize={props.buttonTextSize}
                textAlign={props.buttonTextAlign}
                fontFamily={props.buttonTextFontFamily}>

                {props.buttonText}
              </Text>
          </ContainedButton>
        </VContainerVH>
    );
  };

  const renderSpinner = () => {

    return (

      <VContainerVH
        padding={'16px 0'}>

        <Spinner
          color={ColorCodes.Red1}
          size='150'/>
      </VContainerVH>
    );
  };

  return (

    <>
      <PopUpBanner
        show={props.showPopup}
        text={props.popupText}
        textColor={props.popupTextColor}
        backgroundColor={props.popupBackgroundColor}
        onClose={props.onClosePopup} />

      <Card
        backgroundColor={props.cardBackgroundColor}
        borderRadius={props.cardBorderRadius}
        padding={props.cardPadding}
        maxWidth={props.cardMaxWidth}
        boxSizing={props.cardBoxSizing}
        width={props.cardWidth}>

      {
        props.isRequestLoading

          ? renderSpinner()

          : renderOtpCard()

      }
      </Card>
    </>
  );
};

OtpCard.propTypes = {
  buttonActiveBackgroundColor: PropTypes.string,
  buttonActiveColor: PropTypes.string,
  buttonBorderRadius: PropTypes.string,
  buttonDisabledBackgroundColor: PropTypes.string,
  buttonDisabledBorderColor: PropTypes.string,
  buttonDisabledColor: PropTypes.string,
  buttonHeight: PropTypes.string,
  buttonMaxWidth: PropTypes.string,
  buttonMinHeight: PropTypes.string,
  buttonText: PropTypes.string,
  buttonTextAlign: PropTypes.string,
  buttonTextFontFamily: PropTypes.string,
  buttonTextSize: PropTypes.string,
  buttonWidth: PropTypes.string,
  cardBackgroundColor: PropTypes.string,
  cardBorderRadius: PropTypes.string,
  cardBoxSizing: PropTypes.string,
  cardMaxWidth: PropTypes.string,
  cardPadding: PropTypes.string,
  cardWidth: PropTypes.string,
  closeIcon: PropTypes.string,
  closeIconColor: PropTypes.string,
  closeIconHeight: PropTypes.string,
  closeIconMargin: PropTypes.string,
  closeIconPadding: PropTypes.string,
  closeIconWidth: PropTypes.string,
  isRequestLoading: PropTypes.bool,
  isVerifyLoading: PropTypes.bool,
  onClosePopup: PropTypes.func,
  onResendOtp: PropTypes.func,
  onSubmitOtp: PropTypes.func,
  otpLength: PropTypes.number,
  popupBackgroundColor: PropTypes.string,
  popupText: PropTypes.string,
  popupTextColor: PropTypes.string,
  resendOtpColor: PropTypes.string,
  resendOtpFontFamily: PropTypes.string,
  resendOtpLineHeight: PropTypes.string,
  resendOtpSize: PropTypes.string,
  resendOtpText: PropTypes.string,
  showPopup: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitleAlign: PropTypes.string,
  subtitleColor: PropTypes.string,
  subtitleLineHeight: PropTypes.string,
  subtitlePadding: PropTypes.string,
  subtitleSize: PropTypes.string,
  title: PropTypes.string,
  titleAlign: PropTypes.string,
  titleColor: PropTypes.string,
  titleLineHeight: PropTypes.string,
  titleSize: PropTypes.string,
  titleWeight: PropTypes.string
};

OtpCard.defaultProps = {
  buttonActiveBackgroundColor: ColorCodes.Red1,
  buttonActiveColor: ColorCodes.White,
  buttonBorderRadius: '6px',
  buttonDisabledBackgroundColor: ColorCodes.Grey3,
  buttonDisabledBorderColor: ColorCodes.Grey3,
  buttonDisabledColor: ColorCodes.Grey5,
  buttonHeight: '50px',
  buttonMaxWidth: '328px',
  buttonMinHeight: '50px',
  buttonText: 'Submit OTP',
  buttonTextAlign: 'center',
  buttonTextFontFamily: 'Roboto',
  buttonTextSize: '16px',
  buttonWidth: '100%',
  cardBackgroundColor: ColorCodes.White,
  cardBorderRadius: '15px',
  cardBoxSizing: 'border-box',
  cardMaxWidth: '450px',
  cardPadding: '16px 24px 15px',
  cardWidth: '100%',
  closeIcon: Icons.Close,
  closeIconColor: ColorCodes.Grey7,
  closeIconHeight: '32px',
  closeIconMargin: '0 0 0 auto',
  closeIconPadding: '0 0 32px',
  closeIconWidth: '32px',
  isRequestLoading: false,
  isVerifyLoading: false,
  onClosePopup: () => {},
  onResendOtp: () => {},
  onSubmitOtp: () => {},
  otpLength: 4,
  popupBackgroundColor: '',
  popupText: '',
  popupTextColor: '',
  resendOtpColor: ColorCodes.Blue1,
  resendOtpFontFamily: 'Roboto',
  resendOtpLineHeight: '24px',
  resendOtpSize: '16px',
  resendOtpText: 'Resend OTP',
  showPopup: false,
  subtitle: 'We’ve sent a One-Time PIN (OTP) to msisdnMasked. Please enter it below to continue:',
  subtitleAlign: 'center',
  subtitleColor: ColorCodes.Grey7,
  subtitleLineHeight: '24px',
  subtitlePadding: '20px 0 24px',
  subtitleSize: '16px',
  title: 'Please enter your 4-digit OTP',
  titleAlign: 'center',
  titleColor: ColorCodes.Grey11,
  titleLineHeight: '39x',
  titleSize: '26px',
  titleWeight: 'bold'
};